import { useStationeryCurrencies } from '@shared/utils/currency/useStationeryCurrencies';
import { useStationeryBuyerRegion } from '@shared/utils/currency/useStationeryCurrency';

/**
 * True when the buyer's region is known and card_service does not sell stationery there, so the
 * "Do you have a supported address?" warning should show.
 *
 * Replaces the `printInternationalShipping` and `printDigitalInternationalShipping` Amplitude flags, which
 * held a hand-copied country list keyed on the IP-derived country. The region is the event locale's, else
 * the browser's (the same one that picks the default currency), and the list is the union of `countryCodes`
 * in card_service's `currencyConversionsTable`, so adding a market there is the only change needed.
 *
 * It is a hint, not a gate: the address dropdown only offers sold countries. Print and digital cards share
 * one list. Not restricted while the list is loading or when no region is known, because neither is
 * evidence the buyer is outside the sold markets.
 */
export const useIsRestrictedShippingRegion = (): boolean => {
  const currencies = useStationeryCurrencies();
  const region = useStationeryBuyerRegion();

  if (!currencies || !region) return false;
  return !currencies.some(({ countryCodes }) => countryCodes.includes(region));
};
